// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { auditEventsResponseSchema } from '@/audit/api/types';

/**
 * Fetches audit events for a single invoice by its nano-id key.
 */
export async function getInvoiceAuditEvents(invoiceKey: string) {
  const url = `/v1/invoice/${invoiceKey}/audit`;
  const response = await api.get(url);

  return parseResponse(auditEventsResponseSchema, response.data, {
    schemaName: 'InvoiceAuditEvents',
    endpoint: url,
  });
}
